import { useMemo } from 'react'

export const useCoupon = () => {
	return useMemo(() => {
		const queryParams = new URLSearchParams(window.location.search)
		let couponBase64 = queryParams.get('coupon')
		let code
		let percent

		if(couponBase64 && couponBase64.length) {
			try {
				const couponJson = atob(couponBase64)
				const coupon = JSON.parse(couponJson)
				code = coupon.code
				percent = coupon.percent
			}
			catch(exc) {
				console.log(exc)
			}
		}
		else {
			code = queryParams.get('code')
			percent = queryParams.get('pct')
		}

		if(code && percent) {
			return { code, percent }
		}
		else {
			return null
		}

	}, [window.location.search])
}
